module.exports = __webpack_public_path__ + "img/07.3f24716a.png";